// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"27c4695c","134":"8c4bcb6a","265":"4eb634db","361":"af262952","453":"a5a0f78c","637":"32d483d5","749":"e630ae03","752":"152b6269","851":"56ddbe89","859":"515041d2"}[chunkId] + ".chunk.js";
};